import Input from 'components/common/form/input/Input';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';

function JobPostAdditionalForm() {
  return (
    <Row className="g-5">
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="workingHours">Working Hours</FormLabel>
          <Input
            name="workingHours"
            id="workingHours"
            placeholder="Ex: 9:00 AM to 6:00 PM."
          />
        </FormGroup>
      </Col>
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="benefits">Benefits</FormLabel>
          <Input
            name="benefits"
            id="benefits"
            placeholder="Ex: Health insurance, Paid leave, etc."
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default JobPostAdditionalForm;
